import ObjectDisplayController from "ips/ac/controller/scfld/ObjectDisplay.controller";
import InvitationTokenMailService from "ips/ac/data/invitation/service/InvitationTokenMailService";

/**
 * @namespace ips.ac.data.user.invitation-token
 */
export default class UserInvitationTokenDetails extends ObjectDisplayController {

  public async onSendAgain() {
    const guid = this.getView().getBindingContext().getProperty("Guid");

    await InvitationTokenMailService.resendUserOnboardingMail(this.getView(), guid);
  }
}
